import { createSlice } from "@reduxjs/toolkit";
import { getProducts } from "./_productAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
};

export const productList = createSlice({
  name: "productList",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getProducts.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getProducts.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        const products= payload?.data?.map((p)=>{
          return {
            label: p?.name,
            value: p?.default_price
          }
        })
        state.data = products||[];
      })
      .addCase(getProducts.rejected, (state) => {
        state.isLoading = false;
        state.isSuccess = false;
      })
  },
});
